import { CustomButton } from '@/Components/CustomButton';
import styles from './index.module.css';
import { CustomInput } from '@/Components/CustomInput';
import { useContext } from 'react';
import { NotificationContext } from '@/context/notificationContext';
import { LanguageContext } from '@/context/languageContext';

type Props = {
  link: string;
};
export const ShareModal = ({ link }: Props) => {
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const { t } = useContext(LanguageContext);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      openNotificationWithIcon('info', 'Copied');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const shareLinks = {
    telegram: `https://t.me/share/url?url=${encodeURIComponent(link)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(link)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      link
    )}`,
    instagram: `https://www.instagram.com/?url=${encodeURIComponent(link)}`, // у Instagram нет прямого "share link", можно так
  };

  return (
    <div className={styles.wrapper}>
      <div>
        <CustomInput
          placeholder={link}
          disabled
          className={styles.customInput}
        />
        <CustomButton
          sizeButton="medium"
          typeButton="tertiary"
          onClick={handleCopy}
        >
          <div className={styles.btnContent}>
            <img src="/assets/svg/copy.svg" alt="copy icon" />
            <div>{t('CopyLink')}</div>
          </div>
        </CustomButton>
      </div>
      <div className={styles.otherBtnsWrapper}>
        <div>
          <a
            href={shareLinks.telegram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CustomButton sizeButton="medium" typeButton="tertiary">
              <div className={styles.btnContent}>
                <img src="/assets/svg/telegramLogo.svg" alt="copy icon" />
                <div>Telegram</div>
              </div>
            </CustomButton>
          </a>
          <a
            href={shareLinks.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CustomButton sizeButton="medium" typeButton="tertiary">
              <div className={styles.btnContent}>
                <img src="/assets/svg/whatsappLogo.svg" alt="copy icon" />
                <div>Whatsapp</div>
              </div>
            </CustomButton>
          </a>
        </div>
        <div>
          <a
            href={shareLinks.facebook}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CustomButton sizeButton="medium" typeButton="tertiary">
              <div className={styles.btnContent}>
                <img src="/assets/svg/facebookLogo.svg" alt="copy icon" />
                <div>Facebook</div>
              </div>
            </CustomButton>
          </a>
          <a
            href={shareLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CustomButton sizeButton="medium" typeButton="tertiary">
              <div className={styles.btnContent}>
                <img src="/assets/svg/instagramLogo.svg" alt="copy icon" />
                <div>Instagram</div>
              </div>
            </CustomButton>
          </a>
        </div>
      </div>
    </div>
  );
};
